module.exports = __webpack_public_path__ + "static/pattern-6708e46f754192f4ea2af3b270597f95.png";